import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  IconAvatar,
  HubOutlinedIcon,
} from '@occc-app/design-system';

type AllowCarryOverAdvancedSettingProps = {
  disabled?: boolean;
};

export const AllowCarryOverAdvancedSetting = ({
  disabled = false,
}: AllowCarryOverAdvancedSettingProps) => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Allow Carry Over</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Allow award value to carry over to eligible line items.
        </Typography>
      }
      action={<Switches name='productDiscount.allowCarryOver' data={{ disabled }} />}
      avatar={<IconAvatar Icon={HubOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
